import { FC, useSyncExternalStore } from 'react';
import VersionUpdateDialog from './VersionUpdateDialog';

/**
 * Состояние предложения обновиться — экземпляр `createVersionUpdate` из `@srm/core/version`, его держит модуль
 * приложения. Тип структурный: пакету версия приходит пропсом.
 */
export interface IVersionUpdateSource {
    getState: () => { readonly visible: boolean; readonly mandatory: boolean };
    subscribe: (listener: () => void) => () => void;
    /** «Позже»: отложить предложение на отсрочку приложения (обязательное не откладывается). */
    later: () => void;
}

export interface IConnectedVersionUpdateDialogProps {
    source: IVersionUpdateSource;
    /** «Обновить» @default перезагрузка страницы */
    onReload?: () => void;
}

/**
 * Окно обновления, подключённое к состоянию приложения: обычное предложение (с «Позже») и обязательное (сервер не
 * принимает эту версию клиента — без «Позже» и без закрытия).
 */
export const ConnectedVersionUpdateDialog: FC<IConnectedVersionUpdateDialogProps> = ({ source, onReload }) => {
    const { visible, mandatory } = useSyncExternalStore(source.subscribe, source.getState);
    return <VersionUpdateDialog opened={visible} mandatory={mandatory} onLater={source.later} onReload={onReload} />;
};
